import React from 'react';
import { reduxForm, Field } from 'redux-form';
import CheckboxField from './CheckboxField';
import InputField from './InputField';
import { formatSaveStatus } from '../helpers/formatters';
import FormError from './FormError';

let PortCancelForm = ({ handleSubmit, saveStatus, error, isAdmin, isAtt }) => (
  <div>
    <form onSubmit={handleSubmit}>
      <Field component={InputField} name="remark" />
      {isAtt && isAdmin ? (
        <Field component={CheckboxField} name="force" />
      ) : null}
      {error && <FormError error={error} />}
      <br />
      <button className="btn btn-default" disabled={saveStatus === 'PENDING'}>
        Cancel Port
      </button>
      <span className="submit-status">{formatSaveStatus(saveStatus)}</span>
    </form>
  </div>
);

PortCancelForm = reduxForm({
  form: 'portCancel',
})(PortCancelForm);

export default PortCancelForm;
